import { render, staticRenderFns } from "./ServiceReviewItem.vue?vue&type=template&id=4677f7ea&scoped=true&"
import script from "./ServiceReviewItem.vue?vue&type=script&lang=js&"
export * from "./ServiceReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReviewItem.vue?vue&type=style&index=0&id=4677f7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4677f7ea",
  null
  
)

export default component.exports